import React, { useEffect, useRef } from "react";
import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { OSM } from "ol/source";
import VectorSource from "ol/source/Vector";
import GeoJSON from "ol/format/GeoJSON";
import { Fill, Stroke, Style } from "ol/style";
import { fromLonLat } from "ol/proj";

// GeoJSON 데이터 임포트
import { AreaData } from "../Data/AreaData";

const AreaMap = ({ selectedDistrict }) => {
  const mapRef = useRef(null);

  useEffect(() => {
    if (!selectedDistrict) return; // 선택된 구가 없으면 아무것도 렌더링하지 않음

    // 선택된 구만 필터링
    const filteredFeatures = AreaData.features.filter(
      (feature) => feature.properties.SGG_NM === selectedDistrict
    );

    // 필터링된 데이터를 새로운 GeoJSON 객체로 변환
    const filteredGeoJSON = {
      type: "FeatureCollection",
      features: filteredFeatures,
    };

    const vectorSource = new VectorSource({
      features: new GeoJSON().readFeatures(filteredGeoJSON, {
        featureProjection: "EPSG:3857",
      }),
    });

    const vectorLayer = new VectorLayer({
      source: vectorSource,
      style: new Style({
        fill: new Fill({
          color: "rgba(124, 145, 242, 0.5)", // 파란색 반투명
        }),
        stroke: new Stroke({
          color: "rgba(124, 145, 242, 1)",
          width: 2,
        }),
      }),
    });

    const map = new Map({
      target: mapRef.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        vectorLayer,
      ],
      view: new View({
        center: fromLonLat([126.9784, 37.5665]), // 서울 중심
        zoom: 10,
      }),
    });

    return () => map.setTarget(null);
  }, [selectedDistrict]); // selectedDistrict가 변경될 때마다 다시 렌더링

  return <div ref={mapRef} style={{ width: "40%", height: "100%", borderRadius:"8px" }} />;
};

export default AreaMap;
